import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../../localization/LocaleContext';
import { useCurrency } from '../../localization/CurrencyContext';
import { getCurrencyMeta } from '../../localization/currency';
import './PricingTeaser.css';

const PRICING_CURRENCY_CODES = ['EUR', 'USD', 'GBP'];

export default function PricingTeaser() {
    const { t, toLocalizedPath } = useLocale();
    const { currency } = useCurrency();

    const pricingCurrency = PRICING_CURRENCY_CODES.includes(currency) ? currency : 'USD';
    const symbol = getCurrencyMeta(pricingCurrency).symbol;

    const plans = [
        { planKey: 'free', price: 0 },
        { planKey: 'premium', price: 19.99 },
        { planKey: 'ultimate', price: 29.99 },
    ];

    return (
        <section className="pricing-teaser sp-90">
            <div className="container">
                <h2 className="h-2 h-bold text-center mb-10">{t('pricingTeaser.heading')}</h2>
                <p className="text-center mb-30" style={{ color: '#6b7280' }}>{t('pricingTeaser.subheading')}</p>

                <div className="pricing-teaser-grid">
                    {plans.map((plan) => (
                        <div className={`pricing-teaser-card${plan.planKey === 'premium' ? ' pricing-teaser-card-popular' : ''}`} key={plan.planKey}>
                            {plan.planKey === 'premium' && (
                                <span className="pricing-teaser-badge">{t('pricing.mostPopular')}</span>
                            )}
                            <h3 className="pricing-teaser-plan-name">{t(`pricing.plans.${plan.planKey}.name`)}</h3>
                            <div className="pricing-teaser-price">
                                {plan.price === 0 ? (
                                    <span className="pricing-teaser-amount">{t('pricing.free')}</span>
                                ) : (
                                    <>
                                        <span className="pricing-teaser-amount">{symbol}{plan.price}</span>
                                        <span className="pricing-teaser-period">{t('pricing.monthLabel')}</span>
                                    </>
                                )}
                            </div>
                            <p className="pricing-teaser-desc">{t(`pricing.plans.${plan.planKey}.description`)}</p>
                        </div>
                    ))}
                </div>

                <div className="pricing-teaser-cta">
                    <Link to={toLocalizedPath('pricing')} className="pricing-teaser-link">
                        {t('pricingTeaser.cta')}
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <line x1="5" y1="12" x2="19" y2="12"/>
                            <polyline points="12 5 19 12 12 19"/>
                        </svg>
                    </Link>
                </div>
            </div>
        </section>
    );
}